var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video-data" },
    [
      _c(
        "div",
        { staticClass: "top" },
        [
          _c(
            "div",
            { staticClass: "search-input" },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "请输入标题搜索",
                  icon: "search",
                  "on-icon-click": _vm.getList
                },
                on: { blur: _vm.getList },
                model: {
                  value: _vm.searchValue,
                  callback: function($$v) {
                    _vm.searchValue = $$v
                  },
                  expression: "searchValue"
                }
              })
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "selection",
              attrs: { placeholder: "请选择" },
              on: { change: _vm.pidChange },
              model: {
                value: _vm.pid,
                callback: function($$v) {
                  _vm.pid = $$v
                },
                expression: "pid"
              }
            },
            _vm._l(_vm.pidArr, function(item) {
              return _c("el-option", {
                key: item.label,
                attrs: { label: item.label, value: item.value }
              })
            })
          ),
          _vm.$store.state.utype !== 3
            ? _c(
                "button",
                {
                  staticClass: "my-button add",
                  on: {
                    click: function($event) {
                      _vm.showDialog = true
                    }
                  }
                },
                [_vm._v("新增")]
              )
            : _vm._e()
        ],
        1
      ),
      _c("div", { staticClass: "reminder" }, [_vm._v(_vm._s(_vm.reminder))]),
      _c(
        "div",
        { staticClass: "my-table" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dataLoading,
                  expression: "dataLoading"
                }
              ],
              staticClass: "table",
              attrs: { data: _vm.tableData, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "title",
                  label: "标题",
                  "min-width": "150",
                  "header-align": "center",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "img",
                  label: "封面",
                  "min-width": "150",
                  "header-align": "center",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.img1
                          ? _c(
                              "div",
                              { staticClass: "img-buttons" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        _vm.openImgDialog(scope.row.img1)
                                      }
                                    }
                                  },
                                  [_vm._v("一倍图")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        scope.row.img2
                          ? _c(
                              "div",
                              { staticClass: "img-buttons" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        _vm.openImgDialog(scope.row.img2)
                                      }
                                    }
                                  },
                                  [_vm._v("二倍图")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        scope.row.img_mb
                          ? _c(
                              "div",
                              { staticClass: "img-buttons" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        _vm.openImgDialog(scope.row.img_mb)
                                      }
                                    }
                                  },
                                  [_vm._v("手机图")]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        !scope.row.img1 && !scope.row.img2 && !scope.row.img_mb
                          ? _c("span", [_vm._v("无")])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "video",
                  label: "视频",
                  "min-width": "80",
                  "header-align": "center",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.video && scope.row.video.url != ""
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.openVideoDialog(scope.row.video)
                                  }
                                }
                              },
                              [_vm._v("播放")]
                            )
                          : _c("span", [_vm._v("无")])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sort",
                  label: "排序值",
                  "min-width": "80",
                  "header-align": "center",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "databh",
                  label: "埋点",
                  "min-width": "100",
                  "header-align": "center",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.databh ? scope.row.databh : "无") +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nav_color",
                  label: "文本颜色",
                  "min-width": "100",
                  "header-align": "center",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return scope.row.nav_color
                        ? [
                            _c("span", {
                              staticClass: "color-block",
                              style: { "background-color": scope.row.nav_color }
                            }),
                            _c("span", [_vm._v(_vm._s(scope.row.nav_color))])
                          ]
                        : undefined
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "状态",
                  "min-width": "80",
                  "header-align": "center",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.statusFilter(scope.row.status)) +
                            "\n        "
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm.$store.state.utype !== 3
                ? _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      "min-width": "200",
                      "header-align": "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "operation" },
                              [
                                scope.row.utype === 0
                                  ? [
                                      _c("span", { staticClass: "disable" }, [
                                        _vm._v("修改")
                                      ]),
                                      _c("span", { staticClass: "disable" }, [
                                        _vm._v("删除")
                                      ])
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.openUpdateDialog(scope.row)
                                            }
                                          }
                                        },
                                        [_vm._v("修改")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          on: {
                                            click: function($event) {
                                              _vm.deleteData(scope.row._id)
                                            }
                                          }
                                        },
                                        [_vm._v("删除")]
                                      )
                                    ]
                              ],
                              2
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e()
            ],
            1
          ),
          _c("p", { staticClass: "remark" }, [
            _vm._v(
              "1页最多显示" +
                _vm._s(_vm.maxNum) +
                "条记录，当前共" +
                _vm._s(_vm.count) +
                "条"
            )
          ])
        ],
        1
      ),
      _vm.count > _vm.maxNum
        ? _c(
            "div",
            { staticClass: "my-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  layout: "prev, pager, next",
                  "current-page": _vm.nowPageNum,
                  "page-size": _vm.maxNum,
                  total: _vm.count
                },
                on: {
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function($event) {
                    _vm.nowPageNum = $event
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.isUpdate ? "修改" : "新增",
            visible: _vm.showDialog,
            size: "tiny"
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-position": "right",
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "视频分类：", prop: "pid" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.pid,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "pid", $$v)
                        },
                        expression: "form.pid"
                      }
                    },
                    _vm._l(_vm.pidArr, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    })
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标题：" } },
                [
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { maxlength: 30 },
                    model: {
                      value: _vm.form.title,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form,
                          "title",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.title"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序值：", prop: "sort" } },
                [
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { type: "number" },
                    model: {
                      value: _vm.form.sort,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "sort", _vm._n($$v))
                      },
                      expression: "form.sort"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "埋点：" } },
                [
                  _c("el-input", {
                    staticClass: "input",
                    attrs: { maxlength: 30 },
                    model: {
                      value: _vm.form.databh,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form,
                          "databh",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.databh"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "文本颜色：", prop: "nav_color" } },
                [
                  _c("el-input", {
                    staticClass: "color-input",
                    attrs: { maxlength: 30 },
                    model: {
                      value: _vm.form.nav_color,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form,
                          "nav_color",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.nav_color"
                    }
                  }),
                  _c("el-color-picker", {
                    staticClass: "color-picker",
                    model: {
                      value: _vm.form.nav_color,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nav_color", $$v)
                      },
                      expression: "form.nav_color"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态：", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.form.status,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "status", $$v)
                        },
                        expression: "form.status"
                      }
                    },
                    _vm._l(_vm.statusArr, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    })
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "封面(一倍)：" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "avatar-uploader",
                      attrs: {
                        action:
                          "http://flymeweb-admin.flyme.cn/v1.2/api/image/upload",
                        "http-request": _vm.uploadImg1,
                        "show-file-list": false
                      }
                    },
                    [
                      _vm.form.img1
                        ? _c("div", { staticClass: "img-container" }, [
                            _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.form.img1 }
                            }),
                            _c("i", {
                              staticClass: "el-icon-circle-close",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.removeImg("img1")
                                }
                              }
                            })
                          ])
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon"
                          })
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "封面(二倍)：" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "avatar-uploader",
                      attrs: {
                        action:
                          "http://flymeweb-admin.flyme.cn/v1.2/api/image/upload",
                        "http-request": _vm.uploadImg2,
                        "show-file-list": false
                      }
                    },
                    [
                      _vm.form.img2
                        ? _c("div", { staticClass: "img-container" }, [
                            _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.form.img2 }
                            }),
                            _c("i", {
                              staticClass: "el-icon-circle-close",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.removeImg("img2")
                                }
                              }
                            })
                          ])
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon"
                          })
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "封面(手机)：" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "avatar-uploader",
                      attrs: {
                        action:
                          "http://flymeweb-admin.flyme.cn/v1.2/api/image/upload",
                        "http-request": _vm.uploadImg3,
                        "show-file-list": false
                      }
                    },
                    [
                      _vm.form.img_mb
                        ? _c("div", { staticClass: "img-container" }, [
                            _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.form.img_mb }
                            }),
                            _c("i", {
                              staticClass: "el-icon-circle-close",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  _vm.removeImg("img_mb")
                                }
                              }
                            })
                          ])
                        : _c("i", {
                            staticClass: "el-icon-plus avatar-uploader-icon"
                          })
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "视频：", prop: "video" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action:
                          "http://flymeweb-admin.flyme.cn/v1.2/api/fastdfs/upload",
                        "http-request": _vm.uploadVideoChunks,
                        "file-list": _vm.fileList,
                        "on-remove": _vm.removeVideo
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip"
                        },
                        [
                          _vm._v(
                            "只能上传格式为 mp4 且小于 " +
                              _vm._s(_vm.limitSize) +
                              "mb 的视频"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.saveUnabled },
                  on: { click: _vm.next }
                },
                [_vm._v("保 存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.showDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.showImgDialog, size: "large" },
          on: {
            "update:visible": function($event) {
              _vm.showImgDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "img-wrapper" }, [
            _c("img", { attrs: { src: _vm.currentImg } })
          ])
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showVideoDialog,
            size: "large",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.showVideoDialog = $event
            }
          }
        },
        [
          _vm.showVideoDialog
            ? _c("div", { staticClass: "video-wrapper" }, [
                _c("video", { attrs: { controls: "" } }, [
                  _c("source", {
                    attrs: { src: _vm.video, type: "video/mp4" }
                  }),
                  _vm._v(" 您的浏览器不支持 HTML5 video 标签。\n      ")
                ])
              ])
            : _vm._e()
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLoading,
              expression: "showLoading"
            }
          ],
          staticClass: "loadingDialog"
        },
        [
          _c("div", { staticClass: "loading-container" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _c("p", [_vm._v(_vm._s(_vm.loadingText))]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showButtons,
                    expression: "showButtons"
                  }
                ]
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "cancel-button",
                    attrs: { type: "primary" },
                    on: { click: _vm.uploadCancel }
                  },
                  [_vm._v("取消上传")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03a2565f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a2565f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/index/videoData.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-03a2565f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/index/videoData.vue
// module chunks = 1